import classnames from "classnames";
import { Icon } from "../../../../../icons";
import "./styles/index.scss";

interface FilterTab {
  icon: string;
  label: string;
  parameter_value: string;
  short_label?: string;
}

interface FilterTabsProps {
  breakpoint?: string;
  centeredFilters?: boolean;
  onTypeOfCareChange: (typeOfCare: string) => void;
  rebrand?: boolean;
  tabbed_filters?: boolean;
  type_of_care_filter_tabs?: FilterTab[];
  typeOfCare?: string;
}

export const FilterTabs = ({
  breakpoint,
  centeredFilters,
  onTypeOfCareChange,
  rebrand,
  tabbed_filters,
  type_of_care_filter_tabs,
  typeOfCare,
}: FilterTabsProps) => {

  if (!tabbed_filters || !type_of_care_filter_tabs) {
    return null;
  }

  return (
    <fieldset
      className={classnames("combobox-tab-group", {
        "combobox-tab-group--centered-md": centeredFilters && breakpoint === 'md',
        "combobox-tab-group--centered-desktop": centeredFilters && breakpoint === 'desktop',
        "combobox-tab-group--rebrand": rebrand,
      })}
    >
      <legend className="sr-only">Type of care</legend>
      {type_of_care_filter_tabs.map(tab => (
        <label
          className={classnames("combobox-tab-group__tab", {
            "combobox-tab-group__tab--active": typeOfCare === tab.parameter_value,
          })}
          key={tab.parameter_value}
        >
          <input
            checked={typeOfCare === tab.parameter_value}
            className="combobox-tab-group__input"
            name="typeOfCare"
            type="radio"
            value={tab.parameter_value}
            onChange={() => {
              const newTypeOfCare = tab.parameter_value;
              onTypeOfCareChange(newTypeOfCare);
            }}
          />
          {!centeredFilters ? <Icon icon={tab.icon} /> : null}
          <span className="combobox-tab-group__label--short">
            {tab.short_label !== '' ? tab.short_label : tab.label}
          </span>
          <span className="combobox-tab-group__label">
            {tab.label}
          </span>
        </label>
      ))}
    </fieldset>
  );
};
